import { Box, Button, LinearProgress, useMediaQuery } from "@mui/material";
import { DiscoverViewContext } from "contexts/DiscoverView";
import { OrganizationUserContext } from "contexts/Organization";
import { SubscriptionContext } from "contexts/Subscription";
import { useContext } from "react";
import { Plans } from "schemas/payments";
import { routes } from "schemas/routes";

import { isPage } from "utils/general";

interface Props {
  fromDiscoverFilter?: boolean;
}

const EmailCount = ({ fromDiscoverFilter }: Props) => {
  const { currentOrg } = useContext(OrganizationUserContext);
  const { discoverTab } = useContext(DiscoverViewContext);
  const discoverTabOpen = discoverTab !== null;

  const isSmallScreen = useMediaQuery(
    discoverTabOpen ? "(max-width:1200px)" : "(max-width:900px)",
  );
  const isMediumScreen = useMediaQuery(
    discoverTabOpen ? "(max-width:1325px)" : "(max-width:1000px)",
  );
  const { setUpgradeDialogSource, subscription, plans, emailSents } =
    useContext(SubscriptionContext);

  if (!plans || subscription?.isSubscribed || currentOrg?.isBrand) return <></>;

  const getText = () => {
    if (emailSents > plans[Plans.FREE]?.monthly_limit!) {
      return `${emailSents} emails`;
    }
    return `${emailSents}/${plans[Plans.FREE]?.monthly_limit} emails`;
  };

  const getValue = () => {
    if (emailSents > plans[Plans.FREE]?.monthly_limit!) {
      return 100;
    }
    return (emailSents / (plans[Plans.FREE]?.monthly_limit || 1)) * 100;
  };

  const renderDesktopView = () => {
    return (
      <>
        <Box sx={{ fontSize: 12 }}>
          You've sent <strong>{getText()}</strong> this month.
          <LinearProgress
            variant="determinate"
            value={getValue()}
            sx={{ borderRadius: 4 }}
          />
        </Box>
        <Button
          size="small"
          disableElevation
          variant="contained"
          onClick={() => setUpgradeDialogSource("Top Bar Emails Sent Progress")}
          sx={{ fontSize: { xs: 12, md: 14 } }}
        >
          Upgrade to send more
        </Button>
      </>
    );
  };

  const renderMobileView = () => {
    return (
      <Button
        variant="outlined"
        size="small"
        sx={{ textTransform: "none", fontSize: { xs: 10, md: 14 } }}
        onClick={() => setUpgradeDialogSource("Email Tracking")}
      >
        {getText()} ✉️
      </Button>
    );
  };

  const isSearchPage = isPage(routes.brands) || isPage(routes.inbox);
  if (isSmallScreen && isSearchPage) {
    if (fromDiscoverFilter) {
      return renderMobileView();
    } else {
      return <></>;
    }
  } else if (isMediumScreen) {
    return renderMobileView();
  } else {
    return renderDesktopView();
  }
};

export default EmailCount;
